import React from "react";

import { components } from "react-select";

import type { OptionProps } from "react-select";

import { DenovoIcon } from "../../icons";
import { IOption } from "../interfaces";

export const Option: React.FC<OptionProps<IOption>> = (props) => {
  return (
    <components.Option {...props}>
      <div
        className="flex items-center w-full justify-between"
        style={{ minWidth: 0 }}>
        <div className="flex items-center" style={{ minWidth: 0 }}>
          {props.data.icon && <div className="me-2">{props.data.icon}</div>}
          <span
            className="text-pl font-regular text-current"
            title={
              typeof props.children === "string" ? props.children : undefined
            }
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}>
            {props.children}
          </span>
        </div>
        {props.isSelected && (
          <div>
            <DenovoIcon icon="check" className="ms-3.5" />
          </div>
        )}
      </div>
    </components.Option>
  );
};
